import React, { useEffect, useRef } from "react";
import { DefaultPopupCard } from "./DefaultPopupCard";
import styled from "styled-components";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext from "../../../contexts/UserContext";
import StandardsContext from "../../../contexts/StandardsContext";
import { ReactComponent as Frame290570 } from "../../../assets/images/close-btn.svg";
import { ReactComponent as MarkerPin020 } from "../../../assets/images/marker-pin-009.svg";
import { ReactComponent as MarkerPinW020 } from "../../../assets/images/magnifire.svg";
import MapBackgroundImage from "../../../assets/images/new-map-icon.svg";
import MapBackgroundImageNotFound from "../../../assets/images/map-not-found.svg";
import MapBackgroundInfoImage from "../../../assets/images/info-image-map.svg";
import LocationDetect from "../../../assets/images/location-detect-arrow.svg";
import { getCoordinates, getLocation } from "../../../utils/helperFunctions";
import logGA4Event from "../../../utils/firebase/analytics";
import { getUserLocationByIP } from "../../../utils/LocationLib";
import { StandaloneSearchBox } from "@react-google-maps/api";
import * as Library from "../../../utils/Library";
import Spinner from "../../../assets/images/SpinnerRed.svg";
const StyledPage = styled.div`
    &.frame-29643-loc,
    &.frame-29643-loc * {
        box-sizing: border-box;
    }
    &.frame-29643-loc {
        padding: 0px 10px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-end;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3590-loc {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .frame-295922365 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922364 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313703 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .share-your-location {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 22px;
        line-height: 24px;
        font-weight: 600;
        position: relative;
        align-self: stretch;
    }
    .frame-313706 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        z-index: 9;
    }
    .search-location {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        width: 100%;
    }
    .insert-location-dd {
        color: #8c8c8c;
        text-align: left;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        border: none;
        background: none;
        outline: none;
        width: 100%;
        padding: 0px 0px 0px 34px;
    }
    .insert-location-dd.has-data {
        color: #ffffff;
    }
    .buttons-fixed-width-input-main {
        border-radius: 5px;
        border-style: solid;
        border-width: 1px;
        padding: 0px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 48px;
        position: relative;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
        width: 100%;
    }
    .frame-29480pp-loc-share {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        width: 100%;
    }
    .frame-29592 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .buttons-fixed-width-new-search {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 0px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 48px;
        position: relative;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
    }
    .frame-29480 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .icon {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .search-location2 {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
    }
    .frame-296432 {
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 115px;
        position: relative;
    }
    .frame-35902 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922361 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .group-3413 {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        position: static;
    }
    .group-3664 {
        width: 50px;
        height: 50px;
        position: static;
    }
    .ellipse-80 {
        background: var(--buttons-button-tertiary, #232832);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .navigation-pointer-01 {
        width: 27.27%;
        height: 48%;
        position: absolute;
        right: 57.95%;
        left: 14.77%;
        bottom: 26%;
        top: 26%;
        overflow: visible;
    }
    .map-pins {
        margin: 0 0 0 -12px;
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        position: relative;
        box-shadow: var(--dropdown-ls-box-shadow, 0px 4px 40.9px 0px rgba(0, 0, 0, 0.08));
    }
    .union {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
        overflow: visible;
    }
    .frame-3631 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        height: auto;
        position: absolute;
        left: calc(50% - 15.75px);
        top: calc(50% - 14.5px);
        overflow: visible;
    }
    .frame-295922363 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922362 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313704 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .find-stores-near-you {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
        flex: 1;
    }
    .find-stores-near-you.error {
        color: #ff0000;
    }
    .frame-313705 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .we-use {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .frame-313702 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-lg-solid {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 206px;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vector-1 {
        position: absolute;
        right: 30px;
        bottom: 25px;
    }
    .marker-pin-02-share {
        position: absolute;
        height: 16px;
        width: 16px;
        left: 10px;
    }
    .spinner-text {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .spinner-img {
        animation: spin 1s linear infinite;
        height: 24px;
        width: 24px;
    }
    .btn-lg-solid.loading {
        background: #212121;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
    @media (max-width: 375px) {
        .vector-1 {
            right: 10px;
        }
    }
    @media (min-width: 376px) and (max-width: 390px) {
        .vector-1 {
            right: 20px; /* Applies for screens between 376px and 390px */
        }
    }
`;
const ConfirmationCardStyles = styled.div`
    .frame-29643,
    .frame-29643 * {
        box-sizing: border-box;
    }
    .frame-29643 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-end;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3590 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .frame-295922365 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922364 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313703 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .hey-bo-is-location-based {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 22px;
        line-height: 24px;
        font-weight: 600;
        position: relative;
        align-self: stretch;
    }
    .frame-2959223652 {
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 115px;
        position: relative;
    }
    .frame-35902 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922361 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .group-3413 {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        position: static;
    }
    .group-3664 {
        width: 50px;
        height: 50px;
        position: static;
    }
    .ellipse-80 {
        background: var(--buttons-button-tertiary, #232832);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .info-circle {
        width: 26.5px;
        height: 26.5px;
        position: absolute;
        left: calc(50% - 13px);
        top: calc(50% - 13.5px);
        overflow: visible;
    }
    .frame-295922363 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922362 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313704 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .we-will-use-oslo-norway {
        text-align: center;
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
        flex: 1;
    }
    .we-will-use-oslo-norway-span {
        color: var(--text-text-primary, #ffffff);
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
    }
    .we-will-use-oslo-norway-span2 {
        color: var(--text-text-brand, #f7665f);
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
    }
    .frame-313705 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .we-will-use-this-as-your-generic-location-for-now-it-may-not-be-accurate-depending-on-your-ip-address {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .frame-313702 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922388 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-lg-solid {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .ok {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-lg-solid2 {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .spinner-text {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .spinner-img {
        animation: spin 1s linear infinite;
        height: 24px;
        width: 24px;
    }
    .btn-lg-solid2.loading {
        background: #212121;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;
export default function ShareLocationPopup({ visible, setVisible, onLocationSelected, openBotag }) {
    const {
        isMobile,
        shareLocationSuccess,
        setShareLocationSuccess,
        locationLoader,
        setLocationLoader,
        setNewLocationDetected,
        setLocationDismissed
    } = React.useContext(LayoutContext);
    const { userAddress } = React.useContext(UserContext);
    const newUserCoords = getCoordinates();
    const newUserAddress = getLocation();
    const { setDefaultNotificationCard } = React.useContext(StandardsContext);
    const [showLocationPopup, setShowLocationPopup] = React.useState(true);
    const inputRef = useRef();
    const [locationInput, setLocationInput] = React.useState("");
    const { street, streetNumber, postCode, city, country } = newUserAddress || userAddress || {};
    const address = `${street} ${streetNumber} ${postCode} ${city},${" "}
    ${country}`;
    const validation = street || streetNumber || postCode || city || country;
    /* #region METHODS */
    const handleGMapApiPlaceChanged = () => {
        setNewLocationDetected(false);
        setLocationDismissed(true);
        logGA4Event("Location_Inserted");
        const places = inputRef?.current?.getPlaces();
        if (places && typeof places[Symbol.iterator] === "function") {
            const [place] = places;
            if (place) {
                const latitude = place.geometry.location.lat();
                const longitude = place.geometry.location.lng();

                if (onLocationSelected) {
                    onLocationSelected({ latitude, longitude }, true);
                    setVisible(false);
                    setLocationInput("");
                    Library.showNotification({
                        message: "Location successfully shared!",
                        type: "success",
                        setDefaultNotificationCard
                    });
                    if (isMobile) {
                        const element = document.getElementById("mainContent");
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                }
            }
        } else {
            console.error("GetPlaces did not return an iterable value.");
        }
    };
    const handleCloseButtonClick = () => {
        if (newUserCoords?.latitude || newUserCoords?.longitude || newUserAddress) {
            setVisible(false);
            return;
        }
        setShowLocationPopup(false);
        //TODO: Get the user's location by ?IP? and continue the code below
        logGA4Event("NotSharing_PopUp");
        const callback = data => {
            const { latitude, longitude, country, city, postalCode } = data;
            if (data) {
                onLocationSelected({ latitude, longitude, country, city, postalCode }, false);
                // setVisible(false);
            }
        };
        getUserLocationByIP(callback);
    };
    const handleShareExactLocation = () => {
        logGA4Event("Share_PopUp");
        setLocationLoader(true);
        navigator.geolocation.getCurrentPosition(success, error, options);
    };
    const success = position => {
        const { latitude, longitude } = position.coords;
        if (onLocationSelected) {
            onLocationSelected({ latitude, longitude }, true);
            setVisible(false);
            setShareLocationSuccess(true);
        }
        setLocationLoader(false);
    };
    const error = e => {
        setShareLocationSuccess(false);
        setLocationLoader(false);
        setShowLocationPopup(true);
    };
    const options = {
        enableHighAccuracy: true
    };
    /* #endregion */
    return (
        <DefaultPopupCard visible={visible} backgroundColor="#121212" mobileUsesFullScreen={false}>
            {showLocationPopup ? (
                <StyledPage className="frame-29643-loc">
                    <div className="frame-3590-loc">
                        <Frame290570
                            className={`frame-29057 cursor-pointer ${locationLoader ? "disable" : ""}`}
                            onClick={e => (locationLoader ? e.preventDefault() : handleCloseButtonClick())}
                            style={locationLoader ? { opacity: "0.4" } : {}}
                        />
                    </div>
                    <div className="frame-295922365">
                        <div className="frame-295922364">
                            <div className="frame-313703">
                                <div className="share-your-location">Share your location</div>
                            </div>
                            <div className="frame-313706">
                                <div className="search-location">
                                    <div className="frame-29592">
                                        <div className="buttons-fixed-width-new-search">
                                            <div className="frame-29480">
                                                <div className={`search-location ${locationLoader ? "disable" : ""}`}>
                                                    <div
                                                        className="buttons-fixed-width-input-main"
                                                        style={{
                                                            borderColor: locationInput.length > 0 ? "#f7665f" : "#a6a6a633"
                                                        }}>
                                                        <div className="frame-29480pp-loc-share">
                                                            <MarkerPinW020 className="marker-pin-02-share" />
                                                            <div style={{ width: "100%" }}>
                                                                <StandaloneSearchBox // css class: .pac-container
                                                                    onLoad={ref => (inputRef.current = ref)}
                                                                    onPlacesChanged={handleGMapApiPlaceChanged}
                                                                    containerProps={{
                                                                        className: "my-custom-class pac-container"
                                                                    }}>
                                                                    <input
                                                                        type="text"
                                                                        className={`insert-location-dd ${locationInput ? "has-data" : ""}`}
                                                                        placeholder="Insert location"
                                                                        value={locationInput}
                                                                        onChange={e => {
                                                                            setLocationInput(e.target.value);
                                                                        }}
                                                                        disabled={locationLoader}
                                                                    />
                                                                </StandaloneSearchBox>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-296432">
                            <img
                                src={shareLocationSuccess ? MapBackgroundImage : MapBackgroundImageNotFound}
                                alt=""
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                        <div className="frame-295922363">
                            <div className="frame-295922362">
                                <div className="frame-313704">
                                    {shareLocationSuccess ? (
                                        <div className="find-stores-near-you">Find stores near you</div>
                                    ) : (
                                        <div className="find-stores-near-you error">Your location could not be detected</div>
                                    )}
                                </div>
                                <div className="frame-313705">
                                    <div className="we-use">
                                        {shareLocationSuccess
                                            ? "We use the location you share to show the best stores, deliveries and prices for you."
                                            : "Please insert your location manually."}
                                    </div>
                                </div>
                            </div>
                            {shareLocationSuccess && (
                                <div className="frame-313702">
                                    <div
                                        className={`btn-lg-solid ${locationLoader ? "loading" : ""} cursor-pointer`}
                                        onClick={e => (locationLoader ? e.preventDefault() : handleShareExactLocation())}>
                                        <div className="frame-29590">
                                            <div className="button">
                                                {locationLoader ? (
                                                    <span className="spinner-text">
                                                        <img src={Spinner} alt="" className="spinner-img" />
                                                        &nbsp;
                                                        {"  "}Detecting Location...
                                                    </span>
                                                ) : (
                                                    "Auto-detect my location"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <img className="vector-1" src={LocationDetect} alt="LocationDetect" />
                                </div>
                            )}
                        </div>
                    </div>
                </StyledPage>
            ) : (
                <ConfirmationCard
                    address={address}
                    setVisible={setVisible}
                    handleShareExactLocation={handleShareExactLocation}
                    openBotag={openBotag}
                    validation={validation}
                    setShowLocationPopup={setShowLocationPopup}
                    newUserAddress={newUserAddress}
                    newUserCoords={newUserCoords}
                    locationLoader={locationLoader}
                    setLocationLoader={setLocationLoader}
                />
            )}
        </DefaultPopupCard>
    );
}
export const ConfirmationCard = ({
    address,
    setVisible,
    handleShareExactLocation,
    openBotag,
    validation,
    setShowLocationPopup,
    newUserAddress,
    newUserCoords,
    locationLoader,
    setLocationLoader
}) => {
    return (
        <ConfirmationCardStyles>
            <div className="frame-29643">
                <div className="frame-3590">
                    <div className="frame-3590-loc">
                        <Frame290570
                            className={`frame-29057 cursor-pointer ${locationLoader ? "disable" : ""}`}
                            style={locationLoader ? { opacity: "0.4" } : {}}
                        />
                    </div>
                </div>
                <div className="frame-295922365">
                    <div className="frame-295922364">
                        <div className="frame-313703">
                            <div className="hey-bo-is-location-based">HeyBO is location based</div>
                        </div>
                    </div>
                    <div className="frame-2959223652">
                        <img src={MapBackgroundInfoImage} alt="MapBackgroundInfoImage" style={{ width: "100%" }} />
                    </div>
                    <div className="frame-295922363">
                        <div className="frame-295922362">
                            <div className="frame-313704">
                                <div className="we-will-use-oslo-norway">
                                    <span>
                                        <span className="we-will-use-oslo-norway-span">We will use</span>{" "}
                                        <span className="we-will-use-oslo-norway-span2">{(validation && address) || ""}</span>
                                    </span>
                                </div>
                            </div>
                            <div className="frame-313705">
                                <div className="we-will-use-this-as-your-generic-location-for-now-it-may-not-be-accurate-depending-on-your-ip-address">
                                    We will use this as your generic location for now. It may not be accurate, depending on your IP address.
                                </div>
                            </div>
                        </div>
                        <div className="frame-313702">
                            <div className="frame-295922388">
                                <div
                                    className="btn-lg-solid cursor-pointer"
                                    onClick={e => {
                                        if (locationLoader) {
                                            e.preventDefault();
                                        } else {
                                            if (newUserAddress || newUserCoords) {
                                                setVisible(false);
                                                openBotag();
                                            } else {
                                                setVisible(false);
                                                setShowLocationPopup(true);
                                            }
                                        }
                                    }}
                                    style={locationLoader ? { opacity: "0.4" } : {}}>
                                    <div className="frame-29590">
                                        <div className="ok">Ok</div>
                                    </div>
                                </div>
                                <div
                                    className={`btn-lg-solid2 ${locationLoader ? "loading" : ""} cursor-pointer`}
                                    onClick={e => (locationLoader ? e.preventDefault() : handleShareExactLocation())}>
                                    <div className="frame-29590">
                                        <div className="button">
                                            {locationLoader ? (
                                                <span className="spinner-text">
                                                    <img src={Spinner} alt="" className="spinner-img" />
                                                    &nbsp;
                                                    {"  "}Sharing Location...
                                                </span>
                                            ) : (
                                                "Share my location"
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ConfirmationCardStyles>
    );
};
